import React, { Component } from "react";
import ProductBG from "../../imgs/product-bg.png";
import { Link } from "react-router-dom";

export default class Product extends Component {
  render() {
    return (
      <>
        <Link to="/product" className="product">
          <div
            style={{
              backgroundImage: `url(${ProductBG})`,
            }}
            className="product-img img-fluid"
          >
            <img className="img-fluid" src={this.props.img} />
          </div>
          <p className="text-dark regular text-md text-center mb-1">
            {this.props.name}
          </p>
          <p className="text-dark text-light text-sm text-center">
            {this.props.price}
          </p>
        </Link>
      </>
    );
  }
}
